import { useContext, useState } from "react";
import { Button, Col, Row, Spinner } from "reactstrap";
import HeaderLogo from "src/components/HeaderLogo";
import { translate } from "src/lib/i18n";

import { isNil } from "ramda";
import { Navigate, useLocation } from "react-router-dom";
import { Footer } from "src/components/Footer";
import { ReceiptsContext } from "src/lib/receiptsContext";
import { ReceiptResult } from "./ReceiptsResult";
import { useApi } from "src/lib/ApiProvider";

export const ReceiptsList = () => {
  const { receipts, pagination, loadMoreReceipts } =
    useContext(ReceiptsContext);
  const [loadingMore, setLoadingMore] = useState(false);
  const { api } = useApi();
  const location = useLocation();

  const searchParams = (location.state as any)?.searchParams || {};

  const handleLoadMore = async () => {
    if (!pagination || !pagination.hasMore || loadingMore) return;

    setLoadingMore(true);
    try {
      await loadMoreReceipts(api, searchParams);
    } catch (err) {
      console.error("Failed to load more receipts:", err);
    } finally {
      setLoadingMore(false);
    }
  };

  if (isNil(receipts)) {
    return <Navigate to="/" />;
  }

  return (
    <Col
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "inherit",
        paddingBottom: "16px",
      }}
    >
      <HeaderLogo />
      <Row className="mx-2 text-center">
        <h2>
          <b>{translate("receiptsHome.receiptPortal")}</b>
        </h2>
      </Row>
      <Row className="mx-2 text-center overflow-auto justify-content-center">
        <ReceiptResult receipts={receipts} />
      </Row>

      {pagination && pagination.hasMore && (
        <Row className="mx-2 text-center justify-content-center mt-3">
          <Col xs="auto">
            <Button
              color="primary"
              onClick={handleLoadMore}
              disabled={loadingMore}
            >
              {loadingMore ? (
                <>
                  <Spinner size="sm" className="me-2" />
                  {translate("receiptsList.loadingMore")}
                </>
              ) : (
                translate("receiptsList.loadMore")
              )}
            </Button>
          </Col>
        </Row>
      )}

      {receipts.length > 0 && (
        <Row className="mx-2 text-center justify-content-center mt-2">
          <Col xs="auto">
            <small className="text-muted">
              {translate("receiptsList.showing")} {receipts.length}
            </small>
          </Col>
        </Row>
      )}

      <Footer />
    </Col>
  );
};
